import React from 'react';
import CuponesForm from './CuponesForm';

const EditarCupon = () => {
    return <CuponesForm mode="EDITAR" />;
};

export default EditarCupon;
